import React, { useEffect, useRef, useState } from 'react';
import { Input, Button, message, Row, Col } from 'antd';
import { removeInsUserVip } from '../../../api/inspiration'

export default () => {
  const [loading, setLoading] = useState(false)
  const [accountId, setAccountId] = useState('')
  const [orderId, setOrderId] = useState('')
  const getUsername = () => {
    return localStorage.getItem('username');
  };
  const handleClick = () => {
    if (!accountId || !orderId) return
    setLoading(true)
    try {
      removeInsUserVip({ accountId, orderId }, getUsername()).then(res => {
        if (res.error.code == 0) {
          message.success('操作成功')
          setAccountId('')
          setOrderId('')
        } else {
          message.error(res.error.message)
        }
      }).finally(() => {
        setLoading(false)
      })
    } catch (error) { }
  }

  return <div style={{ height: '100vh' }}>
    <Row
      style={{
        marginBottom: 50,
      }}
    >
      <h1
        style={{
          fontSize: 40,
          margin: 0,
        }}
      >VIP权益管理</h1>
    </Row>
    <Row>
      <Col span={4}>
        <Input placeholder='请输入用户ID' value={accountId} onChange={(e) => { setAccountId(e.target.value) }} /></Col>
    </Row>
    <Row>
      <Col span={4} style={{ margin: '20px 0' }}>
        <Input placeholder='请输入订单号' value={orderId} onChange={(e) => { setOrderId(e.target.value) }} /></Col>
    </Row>
    <Row>
      <Col span={4}>
        <Button type="primary" loading={loading} onClick={() => handleClick()}>
          点击删除权益
        </Button></Col>
    </Row>
  </div>
}